import type { PersonalizationProfile } from '../types/profile'
import type { Language } from '../types/copy'

/**
 * Endpoint real del Web App de Google Apps Script que guarda cada perfil
 * como una fila en Google Sheets. No contiene credenciales ni API keys:
 * es una URL pública de solo escritura.
 */
export const PERSONALIZATION_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbyOeIutwMveMI1vRxJc_p16vkB9NT41lK_pvbb3Wz1lM--ZRWPK5dLd5k3hvbbmv_zR/exec'

/** Estructura exacta que recibe la hoja de cálculo. */
export interface PersonalizationPayload {
  purchase_email: string
  parent_name: string
  child_name: string
  child_gender: string
  child_age: string
  child_interests: string[]
  child_personality: string[]
  development_priorities: string[]
  challenging_situations: string[]
  parent_context: string
  special_detail: string
  parent_message: string
  avoid_topics: string
  consent: boolean
  /** Idioma en que el padre completó el formulario: define el idioma de los audios. */
  language: Language
}

export function buildPayload(
  profile: PersonalizationProfile,
  language: Language,
): PersonalizationPayload {
  return {
    purchase_email: profile.purchase_email.trim(),
    parent_name: profile.parent_name.trim(),
    child_name: profile.child_name.trim(),
    child_gender: profile.child_gender,
    child_age: profile.child_age,
    child_interests: profile.child_interests,
    child_personality: profile.child_personality,
    development_priorities: profile.development_priorities,
    challenging_situations: profile.challenging_situations,
    parent_context: profile.parent_context.trim(),
    special_detail: profile.special_detail.trim(),
    parent_message: profile.parent_message.trim(),
    avoid_topics: '',
    consent: true,
    language,
  }
}

/**
 * Envía el perfil al Web App de Google Apps Script.
 * Se usa `mode: "no-cors"` porque Apps Script no devuelve cabeceras CORS:
 * la respuesta es opaca, por lo que solo detectamos errores de red.
 */
export async function submitPersonalizationProfile(
  profile: PersonalizationProfile,
  language: Language = 'es',
): Promise<PersonalizationPayload> {
  const data = buildPayload(profile, language)

  await fetch(PERSONALIZATION_ENDPOINT, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return data
}
